<div class="container">
    <h1 class="mt-5 text-center">Registrar</h1>
    <hr>
    <app-form-auth [action]="'registrer'"></app-form-auth>
</div>